module.exports = __webpack_public_path__ + "img/help-center.fc8a5621.svg";